import React, { useEffect } from 'react'
import env from '../../../Config'
import './digitalstyles.scss'
const DigitalMarketing = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    })

    return (
        <div className='container-fluid base-pad pt-0'>
            <div>
                <div>
                    <img src={env.baseUrl + '/images/digital-marketing-banner.jpg'} className='img-fluid w-100' />
                </div>
            </div>
            <div className='bg-white sec-pad'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <h6 class="sec-heading">Digital Marketing</h6>
                            <h2 class="base-h1">Best Digital Marketing Services</h2>
                            <p>
                                At CodexCore, we provide result-driven digital marketing services designed to help businesses build a strong online presence, reach the right audience, and generate meaningful growth. Our digital marketing strategies combine SEO, social media marketing, content marketing, search engine advertising, and performance marketing to improve online visibility and attract potential customers. We focus on understanding your business goals, target audience, and industry to create customized campaigns that deliver measurable results. With data-driven strategies, engaging content, and continuous optimization, we help businesses increase website traffic, brand awareness, leads, and conversions in today’s competitive digital landscape.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='bg-light'>
                <div className='container sec-pad'>
                    <div className='row'>
                        <div className='col-lg-5 order-lg-2 d-none d-lg-block'>
                            <img src={env.baseUrl + '/images/strategy.jpg'} className='img-fluid img-rounded' alt='Logo Design' />
                        </div>
                        <div className='col-lg-7 order-lg-1 d-none d-lg-block'>
                            <h3>Strategic Social Media Management</h3>
                            <p>
                                At CodexCore, our Strategic Social Media Management services help businesses build a strong and engaging presence across social media platforms. We create tailored social media strategies based on your brand, target audience, and business goals, combining engaging content, creative visuals, consistent posting, and audience interaction. From content planning and social media marketing to community engagement and performance analysis, we focus on building meaningful connections and increasing brand visibility. With data-driven insights and continuous optimization, we help turn social media into a powerful channel for brand awareness, customer engagement, website traffic, and business growth.
                            </p>
                        </div> 
                    </div>
                </div>
            </div>
            <div className='bg-white'>
                <div className='container sec-pad'>
                    <div className='row'>
                        <div className='col-lg-5'>
                            <img src={env.baseUrl + '/images/seo.jpg'} className='img-fluid' />
                        </div>
                        <div className='col-lg-7 d-none d-lg-block'>
                            <h3>Search Engine Optimization (SEO)</h3>
                            <p>
                                Search Engine Optimization (SEO) services are designed to improve your website’s visibility on search engines and help your business reach the right audience organically. We use a strategic approach that includes keyword research, on-page SEO, technical optimization, content optimization, link building, and performance tracking to strengthen your online presence. Our SEO strategies focus on improving search rankings, attracting high-quality website traffic, and increasing valuable leads and conversions. With continuous analysis and optimization, we help businesses build long-term search visibility and achieve sustainable growth in a competitive digital landscape.
                            </p>
                        </div>
                        
                    </div>
                </div>
            </div>

            <div className='bg-light'>
                <div className='container sec-pad'>
                    <div className='row'>
                        <div className='col-lg-7 order-lg-1'>
                            <h3>Content Marketing</h3>
                            <p>
                                At CodexCore, our Content Marketing services help businesses attract, engage, and convert their target audience through valuable, relevant, and SEO-friendly content. We create strategic content that reflects your brand voice while addressing your customers’ needs, questions, and interests. From website content and blog posts to social media content, landing pages, and marketing materials, our team focuses on delivering clear and engaging messaging that builds trust and strengthens your online presence. By combining creative storytelling with SEO best practices and data-driven insights, we help increase brand awareness, organic traffic, audience engagement, leads, and long-term business growth.
                            </p>
                        </div>
                        <div className='col-lg-5 order-lg-2'>
                            <img src={env.baseUrl + '/images/content-marketing.jpg'} className='img-fluid' />
                        </div>
                         
                    </div>
                </div>
            </div>

            <div className='sec-pad'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-5'>
                            <img src={env.baseUrl + '/images/email.jpg'} className='img-fluid' />
                        </div>
                        <div className='col-lg-7'>
                            <h3>Email Marketing Campaigns</h3>
                            <p>
                                Email Marketing Campaigns help businesses connect with customers, nurture leads, and drive meaningful conversions through personalized and engaging email communication. We create targeted email strategies that include campaign planning, compelling content, audience segmentation, email design, automation, and performance tracking. Every campaign is tailored to your business goals and customer journey, helping you deliver the right message to the right audience at the right time. With data-driven optimization and engaging content, we help increase open rates, customer engagement, website traffic, leads, and conversions, turning email marketing into a powerful channel for long-term business growth.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='bg-light'>
                <div className='container sec-pad'>
                    <div className='row'>
                        <div className='col-lg-7 order-lg-1 d-none d-lg-block'>
                            <h3>Pay-Per-Click (PPC) Advertising</h3>
                            <p>Pay-Per-Click (PPC) Advertising services help businesses reach high-intent customers, generate qualified leads, and maximize their online advertising results. We create targeted PPC campaigns across platforms such as Google Ads and social media advertising networks, focusing on relevant keywords, compelling ad copy, precise audience targeting, and optimized landing pages. From campaign setup and keyword research to budget management, performance tracking, and continuous optimization, we use a data-driven approach to improve click-through rates, conversions, and return on ad spend (ROAS). Our goal is to deliver measurable advertising results while helping your business grow efficiently in a competitive digital market.</p>
                        </div>
                        <div className='col-lg-5 order-lg-2 d-none d-lg-block'>
                            <img src={env.baseUrl + '/images/payperclick.jpg'} className='img-fluid' />
                        </div>  
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DigitalMarketing